<template>
  <v-container
    id="deductionSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Deduction Summary
      </div>
      <v-fab-transition>
        <note
          v-show="displaySection"
          :open-enrollment="openEnrollment"
          :section="sections.deduction"
          summary="true"
        />
      </v-fab-transition>
      <div
        v-if="!loading && deductions && deductions.length"
      >
        <div
          v-for="(deduction, i) in deductions"
          :key="i"
        >
          <v-fab-transition>
            <div
              v-show="displaySection"
              class="oe-summary-subsection mt-6"
            >
              <div class="text-center display-1">
                {{ deduction.deduction }}
              </div>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="deduction.product"
                    label="Product"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="deduction.carrier"
                    label="Carrier"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="deduction.title"
                    label="Title"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="deduction.code"
                    label="Code"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="deduction.taxStatus"
                    label="Tax Status"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="deduction.status"
                    label="Status"
                  />
                </v-col>
              </v-row>
            </div>
          </v-fab-transition>
        </div>
      </div>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!deductions || !deductions.length))"
          type="info"
        >
          No deduction details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'DeductionSummary',

    components: {
      Note: () => import('./Note'),
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,

      loadingDeduction: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      deductions: null,

      deductionResource: new TroodyApi('oeDeduction/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingDeduction)
      },

      sections () {
        return Approvals.sections
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadDeduction()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.deduction.id)
        this.displaySection = this.expanded
      },

      loadDeduction () {
        this.loadingDeduction = true
        console.log(this.openEnrollment)
        this.deductionResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            console.log('deduction')
            console.log(data)
            this.loadingDeduction = false
            this.deductions = data
          })
          .catch((error) => {
            this.loadingDeduction = false
            this.deductions = null
            this.showError(error, 'Failed to load deduction details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
